module.exports = __webpack_public_path__ + "img/attachment.8148aef4.png";